import Jazzicon, { jsNumberForAddress } from 'react-jazzicon';
import { FC } from 'react';
import { truncate } from 'utils/address';
import { RiExternalLinkLine } from 'react-icons/ri';
import { VoteExtended, ProposalResponse } from '../../pages/ProposalDetail';
import { getChoiceString } from 'helpers/snapshot';
import { formatLongNumbers } from 'utils/formatLongNumbers';
import { useWeb3React } from 'hooks/web3';

import {
  GridItem,
  HStack,
  Text,
  Link as ChakraLink,
  Tooltip,
  Grid,
  Tag
} from '@chakra-ui/react';
import { FaSignature } from 'react-icons/fa';

type Props = {
  vote: VoteExtended;
  proposal: ProposalResponse;
};

const VoteRow: FC<Props> = ({ vote, proposal }) => {
  const { account } = useWeb3React();

  return (
    <Grid key={vote.id} spacing={[2, 0]} gridTemplateColumns='repeat(3, 1fr)'>
      <GridItem justifySelf='flex-start' colSpan={[3, null, 1]}>
        <HStack>
          <Jazzicon diameter={20} seed={jsNumberForAddress(vote.voter)} />
          <Text>
            {account && vote.voter === account
              ? 'You'
              : vote.voterEns
              ? vote.voterEns
              : truncate(vote.voter)}
          </Text>
          <ChakraLink
            href={`https://etherscan.io/address/${vote.voter}`}
            isExternal
            fontSize='lg'
          >
            <RiExternalLinkLine />
          </ChakraLink>
          {proposal.space.members.find(
            (admin: string) => vote.voter === admin
          ) && <Tag variant='outline'>core</Tag>}
        </HStack>
      </GridItem>
      <GridItem justifySelf={['left', null, 'center']} colSpan={[3, null, 1]}>
        <Tooltip label={getChoiceString(proposal.proposal, vote.choice)}>
          <Text maxW='260px' isTruncated>
            {getChoiceString(proposal.proposal, vote.choice)}
          </Text>
        </Tooltip>
      </GridItem>
      <GridItem
        justifySelf={['flex-start', null, 'flex-end']}
        colSpan={[3, null, 1]}
      >
        <HStack width='fit-content' _hover={{ cursor: 'pointer' }}>
          <Tooltip
            hasArrow
            label={vote.scores.map((v, i) => (
              <div key={i}>
                {Number(v.toFixed(2)).toLocaleString()}{' '}
                {proposal.proposal.strategies[i].params.symbol}
              </div>
            ))}
            fontSize='md'
            placement='top'
          >
            <Text>
              {formatLongNumbers(Number(vote.balance))} {proposal.space.symbol}
            </Text>
          </Tooltip>
          <Tooltip label='View Signature'>
            <ChakraLink
              href={`https://cloudflare-ipfs.com/ipfs/${vote.id}`}
              isExternal
              fontSize='lg'
            >
              <FaSignature />
            </ChakraLink>
          </Tooltip>
        </HStack>
      </GridItem>
    </Grid>
  );
};

export default VoteRow;
